import { formatPrice } from "features/subscriptions/utils";

import RenderIf from "common/components/RenderIf";
import Skeleton from "common/components/ui/Skeleton";

interface PriceProps {
  priceValue: number;
  priceSubtext: string;
  isLoading: boolean;
}

export default function Price({
  priceValue,
  priceSubtext,
  isLoading,
}: PriceProps) {
  return (
    <div className="flex flex-col gap-1 items-end">
      {isLoading ? (
        <>
          <Skeleton className="h-8 w-20 lg:h-7" />
          <Skeleton className="h-5 w-14 lg:h-4" />
        </>
      ) : (
        <>
          <span className="text-2xl-bold lg:text-lg-bold">
            {formatPrice(priceValue)}
          </span>
          <RenderIf condition={!!priceSubtext}>
            <span className="text-sm-medium lg:text-xs-medium text-black-500">
              / {priceSubtext}
            </span>
          </RenderIf>
        </>
      )}
    </div>
  );
}
